document.addEventListener('DOMContentLoaded', function() {
  function resizePhotoGallery(selector) {
    const swiperSlider = document.querySelectorAll(selector);

    swiperSlider.forEach(function (swiperEl) {
      const swiperGallery = new Swiper(swiperEl, {
        slidesPerView: 1,
        spaceBetween: 20,
        direction: "horizontal",
        loop: false,
        pagination: {
          el: swiperEl.querySelector("._js-block-gallery-slider-pagination"),
        },
        breakpoints: {
          0: {
            slidesPerView: 1,
          },
          834: {
            slidesPerView: "auto",
          },
        },
        navigation: {
          nextEl: swiperEl.closest('._js-block-gallery-container').querySelector("._js-block-gallery-slider-arrows-next"),
          prevEl: swiperEl.closest('._js-block-gallery-container').querySelector("._js-block-gallery-slider-arrows-prev"),
        },
      });
    });
  }

  resizePhotoGallery("._js-block-gallery-slider");
});